<div class="template-selector" #templateSelectorModal>
  <!-- Filtros e controles -->
  <div class="template-selector-filters">
    <nz-space nzSize="middle" nzWrap>
      <!-- Filtro por categoria -->
      <nz-select
        [(ngModel)]="selectedCategory"
        (ngModelChange)="filterTemplates()"
        [nzPlaceHolder]="'builderScreen.templates.filterByCategory' | translateTA"
        nzAllowClear
        nzShowSearch
        style="width: 200px;">
        <nz-option nzValue="" [nzLabel]="'builderScreen.templates.allCategories' | translateTA"></nz-option>
        <nz-option
          *ngFor="let category of categories"
          [nzValue]="category.value"
          [nzLabel]="category.label">
        </nz-option>
      </nz-select>

      <!-- Busca por texto -->
      <nz-input-group
        [nzSuffix]="searchIcon"
        style="width: 300px;">
        <input
          nz-input
          [(ngModel)]="searchTerm"
          (ngModelChange)="filterTemplates()"
          [placeholder]="'builderScreen.templates.searchPlaceholder' | translateTA" />
      </nz-input-group>
      <ng-template #searchIcon>
        <i nz-icon nzType="search"></i>
      </ng-template>

      <!-- Ordenação -->
      <nz-select
        [(ngModel)]="sortBy"
        (ngModelChange)="filterTemplates()"
        style="width: 150px;">
        <nz-option
          *ngFor="let option of sortOptions"
          [nzValue]="option.value"
          [nzLabel]="option.label">
        </nz-option>
      </nz-select>

      <!-- Ordem da ordenação -->
      <div class="button-group">
        <button
          nz-button
          [nzType]="sortOrder === 'asc' ? 'primary' : 'default'"
          (click)="sortOrder = 'asc'; filterTemplates()">
          <i nz-icon nzType="sort-ascending"></i>
        </button>
        <button
          nz-button
          [nzType]="sortOrder === 'desc' ? 'primary' : 'default'"
          (click)="sortOrder = 'desc'; filterTemplates()">
          <i nz-icon nzType="sort-descending"></i>
        </button>
      </div>

      <!-- Botão limpar filtros -->
      <button
        nz-button
        nzType="default"
        (click)="clearFilters()">
        <i nz-icon nzType="clear"></i>
        Limpar Filtros
      </button>
    </nz-space>
  </div>

  <!-- Loading spinner -->
  <div *ngIf="loading" class="template-selector-loading">
    <nz-spin nzSize="large">
      <span>Carregando templates...</span>
    </nz-spin>
  </div>

  <!-- Lista de templates -->
  <div *ngIf="!loading" class="template-selector-content">
    <!-- Templates encontrados -->
    <div *ngIf="filteredTemplates.length > 0" class="template-grid">
      <cdk-virtual-scroll-viewport 
        itemSize="350" 
        class="template-list-viewport"
        style="height: calc(100vh - 300px);">
        <nz-row [nzGutter]="[16, 16]">
          <nz-col
            *cdkVirtualFor="let template of filteredTemplates"
            [nzXs]="24"
            [nzSm]="24"
            [nzMd]="12"
            [nzLg]="12">
          
          <nz-card
            class="template-card"
            [nzTitle]="template.name">
            
            <!-- Conteúdo do card -->
            <div class="template-card-content">
              <!-- Descrição -->
              <p class="template-description">
                {{ template.description }}
              </p>

              <!-- Categoria -->
              <div class="template-category">
                <nz-tag
                  [nzColor]="getCategoryColor(template.category)"
                  [nzIcon]="categoryIcon">
                  {{ getCategoryLabel(template.category) }}
                </nz-tag>
              </div>

              <!-- Informações do template -->
              <div class="template-info">
                <nz-space nzSize="small" nzDirection="vertical">
                  <div class="info-item">
                    <i nz-icon nzType="appstore" nzTheme="outline"></i>
                    <span>{{ getComponentCount(template) }} componentes</span>
                  </div>
                  
                  <div class="info-item">
                    <i nz-icon nzType="table" nzTheme="outline"></i>
                    <span>{{ getGridConfig(template) }}</span>
                  </div>

                  <div class="info-item" *ngIf="hasRegisterButton(template)">
                    <i nz-icon nzType="check-circle" nzTheme="outline" nzColor="#52c41a"></i>
                    <span>{{ 'builderScreen.templates.hasRegisterButton' | translateTA }}</span>
                  </div>

                  <!-- Indicador de validação -->
                  <div class="info-item">
                    <i nz-icon nzType="safety-certificate" nzTheme="outline" [nzColor]="isTemplateValid(template) ? '#52c41a' : '#ff4d4f'"></i>
                    <span>{{ isTemplateValid(template) ? 'Template válido' : 'Template com problemas' }}</span>
                  </div>
                </nz-space>
              </div>

              <!-- Tipos de componentes -->
              <div class="template-components">
                <nz-space nzSize="small">
                  <nz-tag
                    *ngFor="let type of getUniqueComponentTypes(template)"
                    nzSize="small"
                    nzMode="outline">
                    {{ type }}
                  </nz-tag>
                </nz-space>
              </div>

              <!-- Datas -->
              <div class="template-dates">
                <small class="text-muted">
                  Criado: {{ formatDate(template.createdAt) }}<br>
                  Atualizado: {{ formatDate(template.updatedAt) }}
                </small>
              </div>

              <!-- BOTÕES DE AÇÃO -->
              <div class="template-actions" style="margin-top: 16px; display: flex; justify-content: space-between; align-items: center;">
                <!-- Botões de ação secundários -->
                <nz-space nzSize="small">
                  <button
                    *nzSpaceItem
                    nz-button
                    nzType="text"
                    nzSize="small"
                    nz-tooltip
                    [nzTooltipTitle]="'builderScreen.common.view' | translateTA"
                    (click)="openPreviewModal(template)">
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                  </button>

                  <button
                    *nzSpaceItem
                    nz-button
                    nzType="text"
                    nzSize="small"
                    nz-tooltip
                    [nzTooltipTitle]="'builderScreen.common.duplicate' | translateTA"
                    (click)="onDuplicateTemplate(template, $event)">
                    <i nz-icon nzType="copy" nzTheme="outline"></i>
                  </button>

                  <button
                    *nzSpaceItem
                    nz-button
                    nzType="text"
                    nzDanger
                    nzSize="small"
                    nz-tooltip
                    [nzTooltipTitle]="'builderScreen.common.delete' | translateTA"
                    (click)="onDeleteTemplate(template.idTemplate, $event)">
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                  </button>
                </nz-space>

                <!-- Botão principal -->
                <button
                  nz-button
                  nzType="primary"
                  nzSize="small"
                  (click)="applyTemplate(template)">
                  <i nz-icon nzType="check"></i>
                  Aplicar
                </button>
              </div>
            </div>
          </nz-card>
        </nz-col>
      </nz-row>
      </cdk-virtual-scroll-viewport>
    </div>

    <!-- Estado vazio -->
    <nz-empty
      *ngIf="filteredTemplates.length === 0"
      nzNotFoundImage="simple"
      [nzNotFoundContent]="emptyContent">
    </nz-empty>
  </div>

  <!-- Template para ícone de categoria -->
  <ng-template #categoryIcon>
    <i nz-icon [nzType]="getCategoryIcon(template.category)"></i>
  </ng-template>

  <!-- Template para conteúdo vazio -->
  <ng-template #emptyContent>
    <span>
      <p>Nenhum template encontrado</p>
      <p *ngIf="searchTerm || selectedCategory">
        Tente ajustar os filtros ou criar um novo template
      </p>
    </span>
  </ng-template>

  <!-- Template para modal de duplicação -->
  <ng-template #duplicateModalContent>
    <div style="padding: 16px 0;">
      <nz-form-item>
        <nz-form-label nzRequired>Nome do novo template</nz-form-label>
        <nz-form-control>
          <input 
            nz-input
            [(ngModel)]="duplicateTemplateName"
            [placeholder]="'builderScreen.templates.namePlaceholder' | translateTA"
            (keyup.enter)="confirmDuplicate()"
            autofocus
          />
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-template>
</div>

<!-- Modal de Preview -->
<nz-modal
  [(nzVisible)]="showPreviewModal"
  [nzTitle]="previewTemplate?.name"
  [nzWidth]="800"
  [nzFooter]="previewModalFooter"
  (nzOnCancel)="closePreviewModal()">
  
  <div *ngIf="previewTemplate" class="template-preview">
    <!-- Informações do template -->
    <nz-descriptions [nzTitle]="'builderScreen.templates.infoTitle' | translateTA" [nzColumn]="2" nzBordered>
      <nz-descriptions-item [nzTitle]="'builderScreen.templates.category' | translateTA">
        <nz-tag [nzColor]="getCategoryColor(previewTemplate.category)">
          {{ getCategoryLabel(previewTemplate.category) }}
        </nz-tag>
      </nz-descriptions-item>
      
      <nz-descriptions-item [nzTitle]="'builderScreen.templates.components' | translateTA">
        {{ getComponentCount(previewTemplate) }}
      </nz-descriptions-item>
      
      <nz-descriptions-item [nzTitle]="'builderScreen.templates.grid' | translateTA">
        {{ getGridConfig(previewTemplate) }}
      </nz-descriptions-item>
      
      <nz-descriptions-item [nzTitle]="'builderScreen.templates.registerButton' | translateTA">
        <nz-tag [nzColor]="hasRegisterButton(previewTemplate) ? 'green' : 'red'">
          {{ hasRegisterButton(previewTemplate) ? 'Sim' : 'Não' }}
        </nz-tag>
      </nz-descriptions-item>

      <nz-descriptions-item [nzTitle]="'builderScreen.templates.validation' | translateTA">
        <nz-tag [nzColor]="isTemplateValid(previewTemplate) ? 'green' : 'red'">
          {{ isTemplateValid(previewTemplate) ? 'Válido' : 'Com problemas' }}
        </nz-tag>
      </nz-descriptions-item>
    </nz-descriptions>

    <nz-divider></nz-divider>

    <!-- Lista de componentes -->
    <nz-typography>
      <h4 nz-typography-title>Componentes do Template</h4>
    </nz-typography>
    
    <nz-collapse>
      <nz-collapse-panel
        *ngFor="let component of previewTemplate.components; let i = index"
        [nzHeader]="componentHeader"
        [nzActive]="false">
        
        <div class="component-details">
          <nz-descriptions [nzColumn]="2" nzSize="small">
            <nz-descriptions-item [nzTitle]="'builderScreen.inspector.type' | translateTA">
              <nz-tag>{{ component.type }}</nz-tag>
            </nz-descriptions-item>
            
            <nz-descriptions-item [nzTitle]="'builderScreen.templates.position' | translateTA">
              Linha {{ component.position.row }}, Coluna {{ component.position.col }}
            </nz-descriptions-item>
            
            <nz-descriptions-item [nzTitle]="'builderScreen.templates.size' | translateTA">
              {{ component.position.rowSpan }}×{{ component.position.colSpan }}
            </nz-descriptions-item>
            
            <nz-descriptions-item [nzTitle]="'builderScreen.inspector.label' | translateTA">
              {{ component.props.label }}
            </nz-descriptions-item>
            
            <nz-descriptions-item [nzTitle]="'builderScreen.templates.placeholder' | translateTA" *ngIf="component.props.placeholder">
              {{ component.props.placeholder }}
            </nz-descriptions-item>
            
            <nz-descriptions-item [nzTitle]="'builderScreen.inspector.required' | translateTA" *ngIf="component.props.required !== undefined">
              <nz-tag [nzColor]="component.props.required ? 'red' : 'green'">
                {{ component.props.required ? 'Sim' : 'Não' }}
              </nz-tag>
            </nz-descriptions-item>
          </nz-descriptions>
        </div>
      </nz-collapse-panel>
    </nz-collapse>

    <!-- Template para header do componente -->
    <ng-template #componentHeader>
      <nz-space nzSize="small">
        <i nz-icon [nzType]="getComponentIcon(previewTemplate.components[i].type)"></i>
        <span>{{ previewTemplate.components[i].type }}</span>
        <nz-tag nzSize="small">{{ previewTemplate.components[i].props.label }}</nz-tag>
      </nz-space>
    </ng-template>
  </div>
</nz-modal>

<!-- Template para footer do modal -->
<ng-template #previewModalFooter>
  <nz-space>
    <button nz-button nzType="default" (click)="closePreviewModal()">
      Fechar
    </button>
    <button
      *ngIf="previewTemplate"
      nz-button
      nzType="primary"
      (click)="applyTemplate(previewTemplate); closePreviewModal()">
      <i nz-icon nzType="check"></i>
      Aplicar Template
    </button>
  </nz-space>
</ng-template>
